import React, { useMemo } from 'react';
import i18next from 'i18next';
import { Scalars } from '../../@types/codegen/types';
import { List, Item, Tile, Info, Icon, Name, Title, Subtitle, Action } from './wrapper';
import { Link } from '../Link';
import { IconDocument } from '../Icon';

interface IDocumentItem {
  document: Scalars['FileDocument']['output'];
}

const translateContentType = (document: Scalars['FileDocument']['output']) => {
  switch (document.contentType) {
    case 'application/pdf':
      return 'PDF';
    default:
      const formattedContentType =
        document.url && document.url.includes('.') ? document.url.split('.').pop() : '';
      return formattedContentType;
  }
};

export const DocumentItem = ({ document }: IDocumentItem) => {
  const contentType = useMemo(() => translateContentType(document), [document]);

  return (
    <Item>
      <Tile>
        <Info>
          <Icon>
            <IconDocument block />
          </Icon>
          <Name>
            <Title>{document.name}</Title>
            <Subtitle>{contentType}</Subtitle>
          </Name>
        </Info>
        <Action>
          <Link
            href={document.url}
            title={i18next.t('other.openDocument', { document: document.name }) || ''}
            rel="noopener noreferrer nofollow"
            target="_blank"
            $hoverGhost
          >
            {i18next.t('common.open')}
          </Link>
        </Action>
      </Tile>
    </Item>
  );
};

interface IDocumentList {
  documents: Scalars['FileDocument']['output'][];
}

export const DocumentList = ({ documents }: IDocumentList) => (
  <List>
    {documents.map((document, i) => (
      <DocumentItem key={`${document.url}-${i}`} document={document} />
    ))}
  </List>
);

export default DocumentList;
